module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scroll-hor-cont"
  }, [_c('table', {
    staticClass: "form-calculadora"
  }, [_c('tr', {
    staticClass: "form-titles"
  }, _vm._l((_vm.nombresCols), function(item) {
    return _c('th', [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item)
      }
    })])
  })), _vm._v(" "), _vm._l((_vm.formulario), function(item, index) {
    return _c('tr', [_c('td', [_c('p', [(item.nombre != 'Otro ¿cuál?') ? [_vm._v(" " + _vm._s(item.nombre) + "  ")] : _vm._e(), _vm._v(" "), (item.nombre === 'Otro ¿cuál?') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.otro),
        expression: "item.otro"
      }],
      attrs: {
        "aria-label": item.nombre,
        "name": "Valor planeado",
        "placeholder": item.nombre
      },
      domProps: {
        "value": (item.otro)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "otro", $event.target.value)
        }
      }
    }) : _vm._e()], 2)]), _vm._v(" "), _c('td', {
      staticClass: "input-td"
    }, [_c('p', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.valorUno),
        expression: "item.valorUno"
      }],
      attrs: {
        "type": "number",
        "aria-label": item.nombre,
        "name": "Valor real",
        "placeholder": "Ingrese valor"
      },
      domProps: {
        "value": (item.valorUno)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "valorUno", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "input-td"
    }, [_c('p', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.valorDos),
        expression: "item.valorDos"
      }],
      attrs: {
        "type": "number",
        "aria-label": item.nombre,
        "name": "Valor planeado",
        "placeholder": "Ingrese valor"
      },
      domProps: {
        "value": (item.valorDos)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "valorDos", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "text-xs-center",
      attrs: {
        "tabindex": "0",
        "aria-label": 'Diferencia mensual ' + _vm.resultadoDiferencia[index]
      }
    }, [_c('span', {
      staticClass: "font-red "
    }, [_vm._v(_vm._s(_vm.resultadoDiferencia[index]))])])])])
  }), _vm._v(" "), _c('tr', _vm._l((_vm.resultadoTotal), function(item, index) {
    return _c('td', [_c('p', {
      staticClass: "text-xs-center",
      attrs: {
        "tabindex": "0"
      }
    }, [_c('span', {
      staticClass: "font-red "
    }, [_vm._v(_vm._s(index > 0 ? '$' : '') + _vm._s(item))])])])
  })), _vm._v(" "), (_vm.mostrarTotal) ? _c('tr', {
    staticClass: "form-end"
  }, _vm._l((_vm.ingresosMasOtrosIngresos), function(item, index) {
    return _c('td', [_c('p', {
      staticClass: "text-xs-center",
      attrs: {
        "tabindex": "0"
      }
    }, [_c('span', {
      staticClass: "font-red "
    }, [_vm._v(_vm._s(index > 0 ? '$' : '') + _vm._s(item))])])])
  })) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-638e3b28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/FormCalculadora.vue
// module id = 1033
// module chunks = 1